<template>
    <div>
        <Section>
            <div class="top-describe">
                <div class="describe-left">
                    <p>{{title}}</p>
                    <P>{{remark}}</P>
                </div>
            </div>
        </Section>
        <Section>
            <LabelHeader border :title="title"></LabelHeader>
            <div class="bottom-cen">
                 <Form :model="formValidate" :rules="ruleValidate" style="width:850px">
                    <FormItem label="文字描边" prop="fontBorder">
                        <ColorPicker v-model="formValidate.fontBorder" @on-change="changeBorderColor"/>
                        <span class="ml-20px mr-20px">{{formValidate.fontBorder}}</span>
                        <span class="default" @click="clickFontdefault">恢复默认</span>
                    </FormItem>
                    <FormItem label="文字颜色" prop="fontColor">
                        <ColorPicker v-model="formValidate.fontColor" @on-change-change="changeFontColor"/>
                        <span class="ml-20px mr-20px">{{formValidate.fontColor}}</span>
                        <span class="default" @click="clickDefault">恢复默认</span>
                    </FormItem>
                     <FormItem label="楼层经营类型" prop="floorT">
                        <div>
                            <span style="padding-right:20px">商业区</span>
                            <CheckboxGroup style="display:inline-block" @on-change="listen" v-model="business"> 
                                <Checkbox v-for="item in Floors" :label="item.floorName"></Checkbox>
                            </CheckboxGroup>
                        </div>
                        <div>
                            <span style="padding-right:20px">停车场</span>
                            <CheckboxGroup style="display:inline-block" @on-change="listen" v-model="stopCar">
                                <Checkbox v-for="item in Floors" :label="item.floorName"></Checkbox>
                            </CheckboxGroup>
                        </div>
                    </FormItem>
                    <!-- <FormItem label="放大/缩小级别范围" prop="name">
                        <div class="scope">
                            <span class="less" @click="lessNumber">
                                <i class="iconfont icon-yuanquanjianhao"></i>
                            </span>
                            <span class="rank">{{scoped}}</span>
                            <span class="add" @click="addNumber">
                                <i class="iconfont icon-yuanquanjiahao"></i>
                            </span>
                        </div>
                        <span class="ml-5px mr-20px">到22级</span>
                        <span class="mr-20px font-small">*范围值1~22级，默认值15</span>
                        <span style="color:#3384f7;cursor:pointer" @click="scoped = 15">恢复默认</span>
                    </FormItem> -->
                     <FormItem label="初始显示楼层" prop="defaultFloorId">
                        <Select style="width:200px" v-model="formValidate.defaultFloorId" @on-change="listen">
                            <Option v-for="item in Floors" :key="item.floorId" :value="item.floorId">{{item.floorName}}</Option>
                           
                        </Select>
                    </FormItem>
                    <FormItem label="初始地图倾斜度" prop="inclineAngle2">
                        <Input v-model="inclineAngle" style="width:50px" @input="listen"></Input>
                        <span class="ml-10px">度</span>
                        <span class="ml-20px mr-20px font-small">*范围值0~60度，默认值30；0表示平面2D视角</span>
                        <span class="default" @click="inclineDefault">恢复默认</span>
                    </FormItem>
                     <FormItem label="初始地图旋转角度" prop="rotateAngle">
                        <Input v-model="formValidate.rotateAngle" style="width:50px" @input="listen"></Input>
                        <span class="ml-10px">度</span>
                        <span class="ml-20px mr-20px font-small">*范围值-360~360度，默认值0；0表示不旋转。可自定义初始加载地图的旋转角度 </span>
                        <span class="default" @click="rotateDefault">恢复默认</span>
                    </FormItem>
                     <FormItem label="正北偏移角" prop="pointerAngle2">
                        <Input v-model="pointerAngle" style="width:50px" @input="listen"></Input>
                        <span class="ml-10px">度</span>
                        <span class="ml-20px mr-20px font-small">*范围值-360~360度，默认值0；0表示不调整。用以调整指针方向<span style="color:#ff3300">（非专业人员勿动）</span></span>
                        <span class="default" @click="northDefault">恢复默认</span>
                    </FormItem>
                </Form>
            </div>
            <div class="bottom-btn">
                <Button :disabled="!saveBtn" type="primary" @click="submitSave">提交保存</Button>
            </div>
        </Section>
    </div>
</template>

<script>
    import LabelHeader from '@/modules/LabelHeader';

    import menuUtil from '../../../utils/menu-list.js';

    import { Button,Form, FormItem, RadioGroup,Radio,Input,Select,Option,ColorPicker,CheckboxGroup,Checkbox} from 'iview';

    import Request from '../../../utils/request';
        import qs from 'qs';
export default {
    data() {
        return {
            title:'',
            remark:'',
            saveBtn:false,
            floors:'',
            Floors:[],//所有楼层
            business:[],//商业区
            stopCar:[],//停车
             inclineAngle: '',
              pointerAngle: '',
            formValidate: {
                    floorT:'',
                   // mapFont:'',//地图字体
                    fontBorder:'#FFFFFF',//字体描边
                    fontColor:'#454A5E',//字体颜色
                    defaultFloorId:'',
                    floor:'',//楼层:'',
                   
                    rotateAngle: '',
                   
              
                },
            ruleValidate:{
                    floorT:[
                        {required: true, message: '请选择', trigger: 'blur'}
                    ],
                    fontBorder:[
                        { required: true, message: '请选择', trigger: 'blur' }
                    ],
                    fontColor:[
                         { required: true, message: '请选择', trigger: 'blur' }
                    ],
                    defaultFloorId: [
                        { required: true, message: '不能为空', trigger: 'change' }
                    ],
                    inclineAngle2: [
                        { required: true, message: '不能为空', trigger: 'focus' }
                    ],
                    rotateAngle: [
                        { required: true, message: '不能为空', trigger: 'focus' }
                    ],
                    pointerAngle2: [
                        { required: true, message: '不能为空', trigger: 'focus' }
                    ],
                },
           
        };
    },
    
   mounted(){
        let menuObj = menuUtil.getRemark(this.$router.history.current.path);
        this.title = menuObj.menuName;
        this.remark = menuObj.remark;
   },
   components:{
       LabelHeader,
       menuUtil,
       Button,
       Form,
       FormItem,
       RadioGroup, 
       Radio,
       Input,
       Select,
       Option,
       ColorPicker,
       CheckboxGroup,
       Checkbox
   },
   methods:{
       //描边恢复默认
       clickFontdefault(){
           this.formValidate.fontBorder = '#FFFFFF';
           this.listen();
       },
       //文字默认
       clickDefault(){
           this.formValidate.fontColor = '#454A5E';
           this.listen();
       },
       //文字描边
       changeBorderColor(val){
           this.formValidate.fontBorder = val;
           this.listen();
       },
       //文字颜色
       changeFontColor(val){
           this.formValidate.fontColor = val;
           this.listen();
       },
       //倾斜度默认
       inclineDefault(){
           this.inclineAngle = 30;
           this.listen();
       },
       //旋转角度默认
       rotateDefault(){
           this.formValidate.rotateAngle = 0;
           this.listen();
       },
       //正北偏移角默认
       northDefault(){
           this.pointerAngle = 0;
           this.listen();
       },
       //监听函数--监听必填项是否为空
       listen(){
           let line = this.formValidate.fontBorder;//文字描边
           let fontC = this.formValidate.fontColor;//文字颜色
           let bus = this.business;
           let shop = this.stopCar;
           let fId = this.formValidate.defaultFloorId;//初始楼层id
           let angle1 = this.inclineAngle;//倾斜度
           let angle2 = this.formValidate.rotateAngle;//旋转度
           let angle3 = this.pointerAngle;//指针夹角
           let ary = [line,fontC,fId,angle1,angle2,angle3];
           if(!ary.includes('')){
               if(bus.length > 0 || shop.length >0){
                   this.saveBtn = true
               }
               else{
                   this.saveBtn = false
               }
               
           }
           else{
               this.saveBtn = false
           }
       },
       //提交保存
       submitSave(){
           //商业区
           let ary = [];
           this.business.forEach(item =>{
               this.Floors.forEach(el =>{
                   if(item == el.floorName){
                       ary.push(el.floorId)
                   }
               })
           })
           //停车场
           let ary2 = [];
           this.stopCar.forEach(item =>{
               this.Floors.forEach(el =>{
                   if(item == el.floorName){
                       ary2.push(el.floorId)
                   }
               })
           })
           Request.post(`${this.$HOST}/back/setting/map?buildingId=${this.$route.params.buildingId}`,
                qs.stringify({map:JSON.stringify({
               fontBorder: this.formValidate.fontBorder,
               fontColor: this.formValidate.fontColor,
               floorType:{business:ary,stopcar:ary2},
               floor: this.formValidate.defaultFloorId,
               inclineAngle: this.inclineAngle,
               rotateAngle: this.formValidate.rotateAngle,
               pointerAngle: this.pointerAngle,
           })}))
           .then(response =>{
               if(response.data.code ==0){
                   this.$Message.success('提交成功');
                   this.saveBtn = false;
                   this.search();
               }
               else{
                   this.$Message.error(response.data.message);
               }
           })
           .catch(err =>{
                this.$Message.error(err);
           })
       },
       //查询
       search(){
            Request.get(`${this.$HOST}/back/setting?buildingId=${this.$route.params.buildingId}`)
            .then(response =>{
                console.log(response)
                if(response.data.code == 0){
                    let searchData = JSON.parse(response.data.result.map);              
                    this.formValidate.fontBorder = searchData.fontBorder;
                    this.formValidate.fontColor = searchData.fontColor;
                    this.formValidate.defaultFloorId = searchData.floor;
                    this.pointerAngle = searchData.pointerAngle;
                    this.formValidate.rotateAngle = searchData.rotateAngle;
                    this.inclineAngle = searchData.inclineAngle;
                    //楼层经营设为选中
                    let floorOne = searchData.floorType.business;
                    let floorTwo = searchData.floorType.stopcar;
                    let ary = [];
                    let ary2 = [];
                    floorOne.forEach(item =>{
                        this.Floors.forEach(el =>{
                            if(item == el.floorId){
                                ary.push(el.floorName)
                            }
                        })
                    })
                    ary.forEach(item =>{
                        this.business.includes(item) ? '' : this.business.push(item)
                    })

                    floorTwo.forEach(item =>{
                        this.Floors.forEach(el =>{
                            if(item == el.floorId){
                                ary2.push(el.floorName)
                            }
                        })
                    });
                    ary2.forEach(item =>{
                        this.stopCar.includes(item) ? '': this.stopCar.push(item)
                    })
                }
            })
       }
   },
   created(){
        this.search();
        
        //楼层
        let floor = [];
        let POI = JSON.parse(sessionStorage.getItem('POI'));
        POI.forEach((item,index)=>{
            floor.push({floorName:item.fn,floorId:item.fi});
        })

         //楼层去重

        let aryObj = {};
        for(let i = 0 ; i < floor.length ; i++){
            if(!aryObj[floor[i].floorId]){
                this.Floors.push(floor[i]);
                aryObj[floor[i].floorId] = true
            }
        }
   }

};
</script>

<style scoped lang="less">
    @import '../../../styles/comm';
    @import '../../../styles/mainTop';
    .bottom-cen{
        border-bottom:1px solid #e3e8ee;
        padding: 50px;

        .scope{
            line-height: 30px;
            span{
                display: block;
                float: left;
                text-align: center;
                line-height: 28px;
                i{
                    color: #99c1f9;
                }
            }
            .less{
                width: 30px;
                height: 30px;
                border: solid #99c1f9 1px;
                border-radius: 3px 0 0 3px;
                border-right: 0;
                cursor: pointer;
            }
            .rank{
                border: solid #99c1f9 1px;
                width: 60px;
                height: 30px;
                line-height: 30px;
                text-align: center;

            }
            .add{
                width: 30px;
                height: 30px;
                border: solid #99c1f9 1px;
                border-radius: 0 3px 3px 0;
                border-left: 0;
                cursor: pointer
            }
        }
        .font-small{
            color:#9ea7b4;
            font-size:12px
        }
        .default{
            color:#3384f7;
            cursor:pointer
        }
    }
    .bottom-btn{
        padding: 30px 150px;
    }
</style>
